import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {TaskRequests} from "../../../tasks/services/task-requests.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";

export class subTaskStatusButtonCtrl implements IController {

  subTask: any;
  status: any;

  private taskStatusOptions: any;
  private actionable: any;
  private loading: boolean;
  private task: boolean;

  /* @ngInject */
  constructor(private bringozTimeFilter, private tasksConstants, private taskRequests: TaskRequests,
              private deliveriesAlertsService: DeliveriesAlertsService, private $log) {
  }

  $onInit() {
    this.taskStatusOptions = [];
    this.actionable = false;
    this.loading = false;

    if (this.status) {
      this.actionable = _.indexOf(this.tasksConstants.actionableStatuses, this.status) !== -1;
    }
  }

  $onChanges(changes) {
    if (changes.status && !changes.status.isFirstChange()) {
      this.$onInit();
    }
  }

  ///////////////////////////////////////////////////////////////////////////

  onOpenMenu($mdMenu, $event) {
    // _setActions(ctrl.status);
    // if (ctrl.actionable) {
    //     $mdMenu.open($event)
    // }
  }

  onChangeStatus(status) {
    this.loading = true;
    this.taskRequests.changeTaskStatus(status, this.task)
      .then((tasks) => {
        this.task = tasks[0];
        this.status = tasks[0].status;
        this.deliveriesAlertsService.changeTaskStatusSuccess(tasks[0]);
        this.$onInit();
      })
      .catch((error) => {
        this.deliveriesAlertsService.changeTaskStatusError();
        this.$log.error('Failed to change status @taskStatusButton@onChangeStatus', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  _setActions(status) {
    this.taskStatusOptions = [];

    if (status === 'Assigned' ||
      status === 'CourierDeparted' ||
      status === 'CourierArrived' ||
      status === 'CourierHeading' ||
      status === 'ContactNotAvailable') {
      this._setTaskStatusOptions();
    }
  }

  _setTaskStatusOptions() {
    this.taskStatusOptions = [
      this.tasksConstants.status.Assigned,
      this.tasksConstants.status.CourierHeading,
      this.tasksConstants.status.CourierArrived,
      this.tasksConstants.status.CourierDeparted
    ];
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTaskStatusButton', {
    bindings: {
      subTask: '<',
      status: '<',
    },
    template: require('./sub-task-status-button.html').default,
    controller: subTaskStatusButtonCtrl
  });
